Run:

  cofactor external-run skips <run-id>

The CLI distinguishes only what retained data proves:

  filtered_by_selection
    The recorded --grep expression does not match the provider's full test
    title. This is attributable to the run selection.

  reported_skipped_unknown
    The provider reported a skip, but the result format does not preserve
    whether it came from an explicit .skip, a hook, conditional test code, or a
    harness decision.

A skipped count can be expected for a targeted run. For an unfiltered run,
inspect the test source and provider report before assigning intent. If
resultsTruncated is true, remember that never-started tests are absent rather
than represented as skipped.
